import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { SkeletonLoader } from '@frontend/design-system';
import { CallInsightContent } from './call-insight-content';
import { CallInsightHeader } from './call-insight-header';
import { NavigationButtons } from './navigation-buttons';

type CallInsightPanelLoaderProps = {
  onClose?: () => void;
  withHeader?: boolean;
};

export const CallInsightPanelLoader = ({ onClose, withHeader = false }: CallInsightPanelLoaderProps) => {
  const content = (
    <div css={styles.wrapper}>
      <div css={styles.header}>
        <SkeletonLoader shape='circle' width='40px' height='40px' css={styles.avatar} />
        <div css={styles.headerText}>
          <SkeletonLoader width='150px' height='24px' />
          <SkeletonLoader width='90px' height='16px' />
        </div>
      </div>

      <div css={styles.playbar}>
        <SkeletonLoader height='8px' />
      </div>

      <div css={styles.tags}>
        <SkeletonLoader width='40px' height='24px' />
        <SkeletonLoader width='40px' height='24px' />
        <SkeletonLoader width='40px' height='24px' />
      </div>

      <div css={styles.contentList}>
        {Array.from({ length: 4 }).map((_, i) => (
          <SkeletonLoader key={i} width='100%' height='64px' css={styles.card} />
        ))}
      </div>

      <div css={styles.footer}>
        <NavigationButtons disableNext disablePrevious />
      </div>
    </div>
  );

  if (withHeader) {
    return (
      <>
        <CallInsightHeader onClose={onClose} />
        <CallInsightContent isLoading>{content}</CallInsightContent>
      </>
    );
  }

  return content;
};

const styles = {
  wrapper: css`
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing(2)};
    height: 100%;
  `,
  header: css`
    display: flex;
    align-items: center;
    gap: ${theme.spacing(1.5)};
  `,
  avatar: css`
    flex-shrink: 0;
  `,
  headerText: css`
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing(1)};
  `,
  playbar: css`
    margin-top: ${theme.spacing(1)};
    display: flex;
    align-items: center;
    gap: ${theme.spacing(1)};
    justify-content: space-between;
  `,
  tags: css`
    display: flex;
    gap: ${theme.spacing(1)};
  `,
  contentList: css`
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing(1.5)};
  `,
  card: css`
    border-radius: ${theme.borderRadius.medium};
    border: 1px solid ${theme.colors.neutral20};
  `,
  footer: css`
    margin-top: auto;
  `,
};
